module.exports = __webpack_public_path__ + "static/img/numberraise2.dd03066.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/numberraise2.png
// module id = 2dom
// module chunks = 1